import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LogoutFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.38 4.08V19.84H5.42V4.08H14.38ZM15.56 9.82L16.62 8.76L19.82 11.96L16.62 15.16L15.56 14.1L17.72 11.96L15.56 9.82Z" />
    </SvgIcon>
  );
});
